"use strict";

require("core-js/modules/es6.function.bind");

require("core-js/modules/es6.string.starts-with");

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _assign = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/assign"));

var _react = _interopRequireDefault(require("react"));

var _reactJsonTree = _interopRequireDefault(require("react-json-tree"));

var defaultTheme = {
  base00: "transparent",
  base01: "#073642",
  base02: "#586e75",
  base03: "#657b83",
  base04: "#839496",
  base05: "#93a1a1",
  base06: "#eee8d5",
  base07: "#fdf6e3",
  base08: "#dc322f",
  base09: "#cb4b16",
  base0A: "#b58900",
  base0B: "#66BB6A",
  base0C: "#2aa198",
  base0D: "#268bd2",
  base0E: "#6c71c4",
  base0F: "#d33682"
};

function getTheme(themeName) {
  switch (themeName) {
    case "light":
    case "classic":
      {
        return defaultTheme;
      }

    case "dark":
    case "nteract":
      {
        return (0, _assign["default"])({}, defaultTheme, {
          base0B: "#EDF3F7"
        });
      }

    case "halloween":
      {
        return (0, _assign["default"])({}, defaultTheme, {
          base03: "#E28410",
          base0B: "#A22222",
          base0D: "#000000"
        });
      }

    default:
      return defaultTheme;
  }
}

var JsonDisplay = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(JsonDisplay, _React$Component);
  (0, _createClass2["default"])(JsonDisplay, null, [{
    key: "handles",
    value: function handles(mimetype) {
      return mimetype.startsWith("application/json");
    }
  }]);

  function JsonDisplay(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, JsonDisplay);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(JsonDisplay).call(this, props));
    (0, _assertThisInitialized2["default"])((0, _assertThisInitialized2["default"])(_this)).shouldExpandNode = _this.shouldExpandNode.bind((0, _assertThisInitialized2["default"])((0, _assertThisInitialized2["default"])(_this)));
    return _this;
  }

  (0, _createClass2["default"])(JsonDisplay, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      if (nextProps.theme !== this.props.theme || nextProps.data !== this.props.data) {
        return true;
      }

      return false;
    }
  }, {
    key: "shouldExpandNode",
    value: function shouldExpandNode() {
      if (this.props.metadata && this.props.metadata.expanded) {
        return true;
      }

      return false;
    }
  }, {
    key: "render",
    value: function render() {
      var theme = getTheme(this.props.theme);
      return _react["default"].createElement(_reactJsonTree["default"], {
        data: this.props.data,
        theme: theme,
        invertTheme: false,
        hideRoot: true,
        shouldExpandNode: this.shouldExpandNode
      });
    }
  }]);
  return JsonDisplay;
}(_react["default"].Component);

exports["default"] = JsonDisplay;
(0, _defineProperty2["default"])(JsonDisplay, "MIMETYPE", "application/json");
(0, _defineProperty2["default"])(JsonDisplay, "defaultProps", {
  data: {},
  theme: "light",
  metadata: {}
});